// @ts-nocheck 7d1ce531
import constants from '#packages/constants';

const { ACTIONS } = constants.ROOT_COMPS.GFPP;

export default {
  mainActions: [],
  enabledActions: [ACTIONS.SETTINGS, ACTIONS.DESIGN, ACTIONS.HELP],
  mobileEnabledActions: [ACTIONS.HIDE, ACTIONS.HELP],
  presetActions: {
    help: {
      helpId: '123', //TODO - change this
    },
  },
};
